function isNumeric(n: any) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

const toFixed = function(value: number, decimal: number = 0) {
  if (isNumeric(value)) {
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    return value.toFixed(decimal);
  } else {
    return value;
  }
};

export default {
  toFixed
};
